import {
  majorNoticeQueryOption,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import { MajorNoticeSpace } from 'src/types/api'
import React, { useEffect } from 'react'
import SystemNoticeViewPage from 'src/pages/SystemNoticePage/view'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import { Bridge } from 'src/utils/bridge'
import usePageNav from 'src/hooks/usePageNav.hook'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'

export interface SystemNoticePageProps {
  noticeData?: MajorNoticeSpace.Response
  appExit: () => void
}

const SystemNoticePage = () => {
  const { introPageNav } = usePageNav()
  const {
    mutateAsync: noticeCheckMutate,
    data: noticeCheckQueryData,
    isSuccess: noticeCheckSuccess,
  } = useCustomMutation<MajorNoticeSpace.Request, MajorNoticeSpace.Response>(
    majorNoticeQueryOption(),
  )

  const appExit = () => {
    window.location.replace(window.location.origin)
    Bridge.handleReqAppClose()
  }

  useEffect(() => {
    noticeCheckMutate({}).then((res) => {
      const { Body, Header } = res
      if (Header.ErrCode === ERRCODE_SUCCESS && Body?.Contents === '') {
        introPageNav()
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const props: SystemNoticePageProps = {
    noticeData: noticeCheckQueryData?.Body,
    appExit,
  }

  return (
    <React.Fragment>
      <RenderIf when={!noticeCheckSuccess}>
        <Loading.Default />
      </RenderIf>
      <SystemNoticeViewPage {...props} />
    </React.Fragment>
  )
}
export default SystemNoticePage
